import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterState } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbModal, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { DadoBancarioCedente } from 'src/app/models/dado-bancario-cedente';
import { Feriado } from 'src/app/models/feriado';
import { MeioPagamentoPedido } from 'src/app/models/meio-pagamento-pedido';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';
import { Payment, Purchase } from 'src/app/models/purchase';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { FeriadoService } from 'src/app/services/feriado.service';
import { GestorService } from 'src/app/services/gestor.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PerfilService } from 'src/app/services/perfil.service';
import { SaldoCedenteService } from 'src/app/services/saldo-cedente.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { TipoMeioPagamentoPedidoApi } from 'src/app/shared/enums/tipo-meio-pagamento-pedido-api.enum';
import { TipoMeioPagamentoPedidoTela } from 'src/app/shared/enums/tipo-meio-pagamento-pedido-tela.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { CustomDatepickerI18n } from 'src/app/shared/helpers/locale/CustomDatepickerI18n';
import { I18n } from 'src/app/shared/helpers/locale/I18n';
import { NgbDateCustomParserFormatter } from 'src/app/shared/helpers/locale/NgbDateCustomParserFormatter';
import { INovoPedido } from 'src/app/shared/interfaces/novo-pedido.interface';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ResponseBase } from '../../../../../models/response-base';
import { TutorialProgresso } from '../../../../../models/tutorial';
import { TutorialService } from '../../../../../services/tutorial.service';


@Component({
    selector: 'app-nova-compra-confirmar',
    templateUrl: './nova-compra-confirmar.component.html',
    styleUrls: ['./nova-compra-confirmar.component.css'],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
    ]
})
export class NovacompraConfirmarComponent implements OnInit, INovoPedido, AfterViewInit {

    private currentUser: Auth;
    public currentPedidoValue: PedidoCadastro;
    public currentPurchaseValue: Purchase;
    public currentPurchase: Purchase;
    public purchase: Purchase;
    public paymentMethods: MeioPagamentoPedido[];
    public saldosCedente: number;
    public transferencia = false;
    public boleto = false;
    public meioPagamentoPedidoApi = TipoMeioPagamentoPedidoApi;
    public meioPagamentoPedidoTela = TipoMeioPagamentoPedidoTela;
    public dadoBancarioCedenteList: DadoBancarioCedente[];
    public showTransferencia = false;
    private minDateTime: Date = new Date();
    private feriados: Feriado[];
    private dadoBancario: DadoBancarioCedente;
    public saldoDisponivel = 0;
    private temEndereco = false;
    private temDadoBancario = false;
    public nextPageAuth = false;
    public auxValorProduto = [];
    public liberarImediatamente = false;
    public validarPin = false;
    public pinValido = false;
    public pinMensagemErro: string;
    public isResposavel = false;

    public confirmarPedidoCadastro = {
        paymentMethodId: null,
        utilizarSaldo: false,
        dataLiberacao: null,
        dataVencimento: null,
        horaLiberacao: null,
        liberarImediatamente: false
    };

    public confirmarPedidoFormGroup: FormGroup;

    private progresso: TutorialProgresso;

    public get form() {
        return this.confirmarPedidoFormGroup.controls;
    }

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private pedidoDataService: PedidoDataService,
        private pedidoService: PedidoService,
        private alertService: NewAlertService,
        private configDatepicker: NgbDatepickerConfig,
        private calendar: NgbCalendar,
        private balanceService: BalanceService,
        private feriadoService: FeriadoService,
        private dadoBancarioService: DadoBancarioService,
        private parametrosDataService: ParametrosDataService,
        private perfilService: PerfilService,
        private gestorService: GestorService,
        private configTimepicker: NgbTimepickerConfig,
        private tutorialService: TutorialService,
        private modalService: NgbModal,
        private saldoCedenteService: SaldoCedenteService) { }

    ngAfterViewInit() {
        /*const minutes = document.querySelectorAll('.ngb-tp-minute');
        const dots = document.querySelectorAll('.ngb-tp-spacer');
        if (minutes && dots) {
            this.hideMinutes(minutes[0] as HTMLElement, dots[0] as HTMLElement);
        }*/
    }

    hideMinutes(minutes: HTMLElement, dots: HTMLElement) {
        minutes.style.display = 'none';
        dots.style.display = 'none';
    }

    createForm(confirmarPedidoCadastro: any) {
        this.confirmarPedidoFormGroup = this.formBuilder.group({
            paymentMethodId: new FormControl(confirmarPedidoCadastro.paymentMethodId, [
                Validators.required
            ]),
            utilizarSaldo: new FormControl(confirmarPedidoCadastro.utilizarSaldo, []),
            dataLiberacao: new FormControl(confirmarPedidoCadastro.dataLiberacao, [
                Validators.required
            ]),
            horaLiberacao: new FormControl(confirmarPedidoCadastro.horaLiberacao, [
                Validators.required
            ]),
            dataVencimento: new FormControl(confirmarPedidoCadastro.dataVencimento, []),
            liberarImediatamente: new FormControl(confirmarPedidoCadastro.liberarImediatamente)
        });

        if(this.currentPurchaseValue.paymentMethodId && !this.currentPurchaseValue.purchaseUseBalance){
            switch(this.currentPurchaseValue.paymentMethodId){
                case 1:
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.setValue(this.meioPagamentoPedidoTela.Boleto);
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.markAllAsTouched();
                    break;
                case 4:
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.setValue(this.meioPagamentoPedidoTela.Transferencia);
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.markAllAsTouched();
                    break;
            }
        }
    }

    private loadCalendar(feriados: Feriado[]) {
        const currentDate = new Date();
        const feriadosModel: NgbDate[] = [];

        if (feriados) {
            feriados.forEach(obj => feriadosModel.push(new NgbDate(obj.data.getFullYear(), obj.data.getMonth() + 1, obj.data.getDate())));
        }

        this.configDatepicker.markDisabled = (date: NgbDate) => {
            const holiday = feriadosModel.find(x => x.day === date.day && x.month === date.month && x.year === date.year);

            if (holiday) {
                return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7 || holiday.equals(date);
            }

            return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7;
        };

        this.configDatepicker.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
        this.configTimepicker.minuteStep = 30;
    }

    ngOnInit() {
        this.load();
        this.loadOrder();
        this.createForm(this.confirmarPedidoCadastro);
        this.loadParametros();
        this.currentPurchase = this.pedidoDataService.currentPurchaseValue;
        this.loadGuidBanco();

        this.isResposavel = this.perfilService.currentPerfisValue.some(x => x.nomeNormalizado === PerfilNormalizado.Responsavel);
        this.validarPin = BooleanConverter.getBoolean(
            this.parametrosDataService.currentParametrosValue[ParametrosKey.validarPinDestinacaoCredito]
        );
        this.solicitarPin();


    }

    public load() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        /* console.log(this.currentPurchaseValue) */

        this.loadValorTotal();
        this.currentPurchaseValue.payment = new Payment();

        if (this.currentPurchaseValue === null) {
            this.router.navigate(['create'], { relativeTo: this.route.parent });
        }

        this.pedidoService.getMeiosPagamentosOrder().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {

                    this.paymentMethods = response.result;
                    //this.transferencia = this.paymentMethods.some(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaInterbancaria || x.normalizado === this.meioPagamentoPedidoApi.TransferenciaIntrabancaria);
                    this.transferencia = this.paymentMethods.some(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaPix);
                    this.boleto = this.paymentMethods.some(x => x.normalizado === this.meioPagamentoPedidoApi.Boleto);
                } else {
                    this.alertService.error(response.message);
                }
            }
        );

        this.balanceService.getCurrentAccountBalance(this.currentUser.token.assignorGuid)
        .subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.saldoDisponivel = response.result;
                    //this.saldoDisponivel = this.saldosCedente.find(x => x.id === TipoSaldoPessoa.SaldoDisponivel).valor;
                } else {
                    this.alertService.error(response.message);
                }
            },error =>{console.log(error)}
        );

        this.feriadoService.getAll().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    response.result.forEach(obj => {
                        obj.data = new Date(obj.data);
                    });
                    this.feriados = response.result;
                    this.loadCalendar(response.result);

                    if(this.currentPurchaseValue.purchaseUseBalance){
                        this.confirmarPedidoFormGroup.controls.utilizarSaldo.setValue(true);
                        this.confirmarPedidoFormGroup.controls.utilizarSaldo.markAllAsTouched();
                        this.aplicarUtilizarSaldo();
                    }
                } else {
                    this.alertService.error(response.message);
                }
            }
        );

    }

    loadValorTotal() {
        const totalProduto = [];
        this.currentPurchaseValue.purchaseItens.forEach(a => {
            totalProduto.push(0);
        });
        let total = 0;
        let i = 0;
        for (const s of this.currentPurchaseValue.purchaseItens) {
            if(s.order?.orderValue)
                totalProduto[i] = s.order?.orderValue + totalProduto[i];
            i++;
        }
        this.auxValorProduto = totalProduto;
        for (let i = 0; i < this.auxValorProduto.length; i++) {
            total += this.auxValorProduto[i];
        }
        this.currentPurchaseValue.purchaseValue = Math.round(total * 1000) / 1000;
        this.currentPurchaseValue.purchaseValuePay = Math.round(total * 1000) / 1000;
        this.currentPurchaseValue.purchaseToPayValue = Math.round(total * 1000) / 1000;
    }

     loadParametros() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.temEndereco]) {
                this.temEndereco = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.temEndereco]
                );
            }

            if (parametros[ParametrosKey.temDadoBancario]) {
                this.temDadoBancario = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.temDadoBancario]
                );
            }
        }
    }

    public loadDadosBancarios() {
        if (this.transferencia) {
            this.dadoBancarioService.getAll(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.dadoBancarioCedenteList = response.result;
                        const preferencial = this.dadoBancarioCedenteList.find(x => x.preferencial === true);
                        this.confirmarPedidoFormGroup.controls.dadoBancarioGuid.setValue(preferencial.dadoBancarioGuid);
                    } else {
                        this.alertService.error(response.message);

                    }
                }
            );
        }
    }

    public loadGuidBanco() {
        this.dadoBancarioService.getAll(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.dadoBancarioCedenteList = response.result;
                    const preferencial = this.dadoBancarioCedenteList.find(x => x.preferencial === true);
                    if(preferencial === undefined){
                        this.dadoBancario = this.dadoBancarioCedenteList[0];
                    }else{
                        this.dadoBancario = preferencial;
                    }
                } else {
                    this.alertService.error(response.message);

                }
            }
        );
    }

    private loadOrder() {
        const currentDate = new Date();

        if (this.currentPurchaseValue.payment) {
            if (this.currentPurchaseValue.paymentMethodId) {
                this.confirmarPedidoCadastro.paymentMethodId = this.currentPurchaseValue.paymentMethodId;
            }

            if (this.currentPurchaseValue.purchaseUseBalance) {
                this.confirmarPedidoCadastro.utilizarSaldo = this.currentPurchaseValue.purchaseUseBalance;
            }
        }


        if (this.currentPurchaseValue.purchaseItens[0].order.releaseDate) {
            this.currentPurchaseValue.purchaseItens[0].order.releaseDate = new Date(this.currentPurchaseValue.purchaseItens[0].order.releaseDate);
            this.confirmarPedidoCadastro.dataLiberacao = {
                year: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getFullYear(),
                month: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getMonth() + 1,
                day: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getDate()
            };
            this.confirmarPedidoCadastro.horaLiberacao = {
                hour: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getHours() + 3,
                minute: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getMinutes(),
                second: this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getSeconds()
            };
        } else {
            this.confirmarPedidoCadastro.dataLiberacao = null;
            this.confirmarPedidoCadastro.horaLiberacao = { hour: 0, minute: 0, second: 0 };
        }
    }

    selectDadoBancario() {
        this.dadoBancario = this.dadoBancarioCedenteList.find(x => x.dadoBancarioGuid === this.confirmarPedidoFormGroup.controls.dadoBancarioGuid.value);
        this.loadMinDateTime(this.meioPagamentoPedidoTela.Transferencia);
    }

    selectMeioPagamentoBoleto() {
        /*if (!this.temDadoBancario) {
            this.alertService.error('Para gerar pagamentos com boleto é necessário ter uma conta bancária cadastrada! Para cadastrar navegue até Administrativo > Dados bancários');
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.setValidators([Validators.required]);
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.setValue(null);
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.updateValueAndValidity();
        }*/

        if (!this.temEndereco) {
            this.alertService.error('Para gerar pagamentos com boleto é necessário ter um endereço cadastrado! para cadastrar navegue até Administrativo > Dados da empresa');
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.setValidators([Validators.required]);
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.setValue(null);
            this.confirmarPedidoFormGroup.controls.paymentMethodIdnvalid.updateValueAndValidity();
        }

        if (this.temEndereco/* && this.temDadoBancario*/) {
            this.currentPurchaseValue.paymentMethodId = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.Boleto).meioPagamentoPedidoId;
        }
    }

    public loadMinDateTime(tipoMeioPagamento: TipoMeioPagamentoPedidoTela) {
        this.minDateTime = new Date();
        let meioPagamento: MeioPagamentoPedido;
        if (this.currentPurchaseValue.purchaseValuePay > 0) {
            if (tipoMeioPagamento === TipoMeioPagamentoPedidoTela.Boleto) {
                meioPagamento = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.Boleto);
                if (meioPagamento) {
                    let dias = meioPagamento.horaLeadTime / 24;
                    let horasFinalDeSemana = 0;
                    const currentDate = new Date();
                    currentDate.setHours(0);
                    if (dias > 0) {
                        dias = Math.ceil(dias);
                    }

                    for (let i = 1; i <= dias; i++) {

                        if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
                            horasFinalDeSemana = horasFinalDeSemana + 24;
                        }
                        currentDate.setHours(currentDate.getHours() + 24);
                    }

                    this.minDateTime.setHours(this.minDateTime.getHours() + (meioPagamento.horaLeadTime));
                }
            }

            if (tipoMeioPagamento === TipoMeioPagamentoPedidoTela.Transferencia) {

                meioPagamento = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaPix);
                if (meioPagamento) {
                    let dias = meioPagamento.horaLeadTime / 24;
                    let horasFinalDeSemana = 0;
                    const currentDate = new Date();
                    currentDate.setHours(0);

                    if (dias > 0) {
                        dias = Math.ceil(dias);
                    }

                    for (let i = 1; i <= dias; i++) {
                        if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
                            horasFinalDeSemana = horasFinalDeSemana + 24;
                        }
                        currentDate.setHours(currentDate.getHours() + 24);
                    }

                    this.minDateTime.setHours(this.minDateTime.getHours() + (meioPagamento.horaLeadTime));
                    this.confirmarPedidoFormGroup.addControl('dadoBancarioGuid', new FormControl(''));
                    this.showTransferencia = true;

                    if (this.dadoBancario) {
                        if (this.dadoBancario.conveniado) {
                            this.currentPurchaseValue.paymentMethodId = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaIntrabancaria).meioPagamentoPedidoId;
                            meioPagamento = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaIntrabancaria);
                            this.minDateTime = new Date();
                            this.minDateTime.setHours(this.minDateTime.getHours() + meioPagamento.horaLeadTime);
                        }
                        else{
                            this.currentPurchaseValue.paymentMethodId = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaPix).meioPagamentoPedidoId;
                        }
                    }
                    else{
                        this.currentPurchaseValue.paymentMethodId = this.paymentMethods.find(x => x.normalizado === this.meioPagamentoPedidoApi.TransferenciaPix).meioPagamentoPedidoId;
                    }
                }
            } else {
                this.showTransferencia = false;
                this.confirmarPedidoFormGroup.removeControl('dadoBancarioGuid');
            }

            let dataValida = false;
            while (!dataValida) {
                let testar = false;

                if (this.feriados.some(x => x.data.getFullYear() === this.minDateTime.getFullYear() && x.data.getMonth() === this.minDateTime.getMonth() && x.data.getDate() === this.minDateTime.getDate())) {
                    this.minDateTime.setHours(this.minDateTime.getHours() + 24);
                    testar = true;
                }

                // if (this.minDateTime.getDay() === 0) {
                //     this.minDateTime.setHours(this.minDateTime.getHours() + 24);
                //     testar = true;
                // }

                // if (this.minDateTime.getDay() === 6) {
                //     this.minDateTime.setHours(this.minDateTime.getHours() + 48);

                //     testar = true;
                // }

                dataValida = !testar;
            }

        } else if (this.currentPurchaseValue.purchaseValuePay <= 0) {
            this.showTransferencia = false;
            this.confirmarPedidoFormGroup.removeControl('dadoBancarioGuid');
        }

        this.minDateTime.setHours(this.minDateTime.getHours() + 1);
        this.minDateTime.setMinutes(0);
        this.minDateTime.setSeconds(0);

        this.configDatepicker.minDate = {
            year: this.minDateTime.getFullYear(),
            month: this.minDateTime.getMonth() + 1,
            day: this.minDateTime.getDate()
        };

        this.confirmarPedidoFormGroup.controls.dataLiberacao.setValidators([
            Validators.required,
            GenericValidator.minDate(new NgbDate(this.minDateTime.getFullYear(), this.minDateTime.getMonth() + 1, this.minDateTime.getDate()))
        ]);
        this.confirmarPedidoFormGroup.controls.dataVencimento.setValidators([
            GenericValidator.minDate(new NgbDate(this.minDateTime.getFullYear(), this.minDateTime.getMonth() + 1, this.minDateTime.getDate()))
        ]);

        this.confirmarPedidoFormGroup.controls.dataLiberacao.updateValueAndValidity();
        this.confirmarPedidoFormGroup.controls.dataVencimento.updateValueAndValidity();
    }

    public aplicarUtilizarSaldo() {
        this.loadMinDateTime(null);
        this.currentPurchaseValue.purchaseValuePay = this.currentPurchaseValue.purchaseValue;
        if (this.confirmarPedidoFormGroup.controls.utilizarSaldo.value) {
            if (this.saldoDisponivel >= 0) {
                this.currentPurchaseValue.purchaseValuePay = this.currentPurchaseValue.purchaseValue - this.saldoDisponivel;

                if (this.currentPurchaseValue.purchaseValuePay <= 0) {
                    this.currentPurchaseValue.purchaseValuePay = 0;
                    // remover obrigatoriedade do meio de pagamento
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.setValidators([]);
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.updateValueAndValidity();
                    this.confirmarPedidoFormGroup.controls.paymentMethodId.setValue(null);
                }
            } else {
                this.confirmarPedidoFormGroup.controls.utilizarSaldo.setValue(false);
            }
        } else {
            this.confirmarPedidoFormGroup.controls.paymentMethodId.setValidators([Validators.required]);
            this.confirmarPedidoFormGroup.controls.paymentMethodId.updateValueAndValidity();
            this.confirmarPedidoFormGroup.controls.liberarImediatamente.setValue(false);
            this.currentPurchaseValue.purchaseValuePay = this.currentPurchaseValue.purchaseValue;
        }
    }

    public savePedido() {

        if (this.currentPurchaseValue.paymentMethodId === 0) {
            this.currentPurchaseValue.paymentMethodId = 0;
        }

        this.currentPurchaseValue.purchaseUseBalance = this.confirmarPedidoFormGroup.controls.utilizarSaldo.value;
        let dataLiberacaoPedido = new Date();

        if (this.confirmarPedidoCadastro.dataLiberacao && this.confirmarPedidoCadastro.horaLiberacao) {
            dataLiberacaoPedido = new Date(this.confirmarPedidoCadastro.dataLiberacao.year, this.confirmarPedidoCadastro.dataLiberacao.month - 1, this.confirmarPedidoCadastro.dataLiberacao.day,
                this.confirmarPedidoCadastro.horaLiberacao.hour - 3, this.confirmarPedidoCadastro.horaLiberacao.minute, this.confirmarPedidoCadastro.horaLiberacao.second);
        }

        this.currentPurchaseValue.purchaseItens[0].order.releaseDate = dataLiberacaoPedido;

        this.purchase = JSON.parse(JSON.stringify(this.currentPurchaseValue));

        this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {

                        this.purchase.purchaseId = response.result.purchaseId
                        this.purchase.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                        this.purchase.purchaseItens[i].order.orderDescription = response.result.purchaseItens[i].order.orderDescription;
                        this.purchase.purchaseItens[i].purchaseItemId = response.result.purchaseItens[i].purchaseItemId;
                        this.purchase.purchaseItens[i].purchaseId = response.result.purchaseId;
                    }
                    this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                        res => {
                            if (res.status === ApiError.Sucesso) {
                                this.alertService.success('Recarga salva');
                            } else {
                                this.alertService.success('Erro ao salvar a recarga');
                            }
                    });

                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    }

    public newDadosBancarios() {
        const state: RouterState = this.router.routerState;
        this.router.navigate(['portal/dadobancario/create'], { queryParams: { urlReturn: state.snapshot.url } });
    }

    public previous() {
        this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });
    }

    public next() { }

    public isDisabled(date: NgbDateStruct, current: { month: number }) {
        return false;
    }

    public addDadosPurchase() {
        const currentDate = new Date();
        this.currentPurchase.payment = new Payment();
        if(this.dadoBancario)
            this.currentPurchase.payment.bankGuid = this.dadoBancario.dadoBancarioGuid;
        this.currentPurchase.purchaseValue = this.currentPurchaseValue.purchaseValue;
        this.currentPurchase.paymentMethodId = this.currentPurchaseValue.paymentMethodId;
        this.currentPurchase.purchaseUseBalance = this.currentPurchaseValue.purchaseUseBalance;
        this.currentPurchase.identifier = this.currentPurchaseValue.identifier;
        this.currentPurchase.purchaseValuePay = this.currentPurchaseValue.purchaseValuePay;
        this.currentPurchase.purchaseItens.forEach(e => {
            e.order.releaseDate = currentDate;
        });
    }

    private updateProgressoTutorial() {
        this.tutorialService.updateProgresso(this.tutorialService.createAtualizarProgresso(5)).subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {

                this.progresso = resp.result;
                const passo = this.tutorialService.getLocalStoragePassoAtual;
                passo.alreadyDone = true;
                this.tutorialService.setLocalStoragePassoAtual(passo);

            }
        }, error => {
            console.log(error);
        });
    }

    public onSubmit(confirmarPedidoCadastro: any) {

        const currentDate = new Date();
        this.addDadosPurchase();
        if (this.confirmarPedidoFormGroup.controls.liberarImediatamente.value) {
            this.confirmarPedidoFormGroup.controls.horaLiberacao.clearValidators();
            this.confirmarPedidoCadastro.dataLiberacao = {
                year: currentDate.getFullYear(),
                month: currentDate.getMonth() + 1,
                day: currentDate.getDate()
            };
            this.confirmarPedidoCadastro.horaLiberacao = {
                hour: currentDate.getHours(),
                minute: currentDate.getMinutes(),
                second: currentDate.getSeconds() + 30
            };
        }
        this.confirmarPedidoFormGroup.controls.dataLiberacao.setValue(this.confirmarPedidoCadastro.dataLiberacao);
        this.confirmarPedidoFormGroup.controls.horaLiberacao.setValue(this.confirmarPedidoCadastro.horaLiberacao);
        this.confirmarPedidoFormGroup.controls.horaLiberacao.updateValueAndValidity();
        let dataLiberacaoPedido = new Date();
        let dataLiberacaoPedidoRaw = new Date();
        let dataVencimentoPedido = null;


        if (this.confirmarPedidoCadastro.dataLiberacao && this.confirmarPedidoCadastro.horaLiberacao) {
            dataLiberacaoPedido = new Date(
                this.confirmarPedidoCadastro.dataLiberacao.year,
                this.confirmarPedidoCadastro.dataLiberacao.month - 1,
                this.confirmarPedidoCadastro.dataLiberacao.day,
                this.confirmarPedidoCadastro.horaLiberacao.hour - 3,
                this.confirmarPedidoCadastro.horaLiberacao.minute,
                this.confirmarPedidoCadastro.horaLiberacao.second
            );

            dataLiberacaoPedidoRaw = new Date(
                this.confirmarPedidoCadastro.dataLiberacao.year,
                this.confirmarPedidoCadastro.dataLiberacao.month,
                this.confirmarPedidoCadastro.dataLiberacao.day,
                this.confirmarPedidoCadastro.horaLiberacao.hour,
                this.confirmarPedidoCadastro.horaLiberacao.minute,
                this.confirmarPedidoCadastro.horaLiberacao.second
            );
        }

        if(this.confirmarPedidoCadastro.dataVencimento && this.form.paymentMethodId.value == this.meioPagamentoPedidoTela.Boleto){
            dataVencimentoPedido = new Date(
                this.confirmarPedidoCadastro.dataVencimento.year,
                this.confirmarPedidoCadastro.dataVencimento.month - 1,
                this.confirmarPedidoCadastro.dataVencimento.day
            );
        }

        if (dataLiberacaoPedidoRaw >= this.minDateTime && !this.confirmarPedidoFormGroup.controls.liberarImediatamente.value) {
            if (dataLiberacaoPedidoRaw.getDate() === currentDate.getDate() && dataLiberacaoPedidoRaw.getMonth()-1 === currentDate.getMonth()) {
                this.confirmarPedidoFormGroup.controls.horaLiberacao.setValidators([
                    Validators.required,
                    GenericValidator.minTime({ hour: this.minDateTime.getHours() })
                ]);
            } else {
                this.confirmarPedidoFormGroup.controls.horaLiberacao.setValidators([
                    Validators.required
                ]);
            }
            this.confirmarPedidoFormGroup.controls.horaLiberacao.updateValueAndValidity();
        }

        if (this.confirmarPedidoFormGroup.valid) {

            this.currentPurchaseValue.purchaseUseBalance = this.confirmarPedidoFormGroup.controls.utilizarSaldo.value;

            this.currentPurchaseValue.purchaseItens.forEach(item => {
                item.order.releaseDate = dataLiberacaoPedido;
                item.order.dueDate = dataVencimentoPedido;
            })

            if (this.currentPurchaseValue.purchaseValuePay > 0) {
                const meioPagamentoEscolhido = this.paymentMethods.find(x => x.meioPagamentoPedidoId === this.currentPurchaseValue.paymentMethodId);

                if (meioPagamentoEscolhido.normalizado === this.meioPagamentoPedidoApi.TransferenciaPix || this.meioPagamentoPedidoApi.TransferenciaIntrabancaria) {

                    if (this.dadoBancario) {
                        this.currentPurchaseValue.payment.bankGuid = this.dadoBancario.dadoBancarioGuid;
                    }
                    this.currentPurchaseValue.purchaseItens.forEach(compraItem => {
                        compraItem.order.orderItens.forEach(cards =>{
                            cards.providedValue = cards.providedValue;
                            cards.referenceValue = cards.referenceValue;
                        })
                    });
                    this.currentPurchaseValue.purchaseId = this.currentPurchaseValue.purchaseId;

                    this.pedidoService.finishPurchase(this.currentUser.token.assignorGuid, this.currentPurchaseValue).subscribe(
                        response => {
                            if (response.status === ApiError.Sucesso) {

                                if(response.result != null)
                                    this.pedidoDataService.setCurrentPurchasePaymentValue(response.result)

                                    this.pedidoService.getPurchaseById(this.currentPurchaseValue.purchaseId,this.currentUser.token.assignorGuid, false).subscribe(
                                        responseInfo => {
                                            if(responseInfo.status === ApiError.Sucesso){
                                                this.pedidoDataService.setCurrentPurchaseInfoValue(responseInfo.result);
                                                this.nextPageAuth = true;
                                                this.router.navigate(['pagamento'], { relativeTo: this.route.parent });
                                            }
                                            else {
                                                this.alertService.error(responseInfo.message);
                                            }
                                        }
                                    )
                            } else {
                                this.alertService.error(response.message);
                            }
                        }
                    );
                }
            } else if (this.currentPurchaseValue.purchaseValuePay <= 0) {
                this.currentPurchaseValue.paymentMethodId = null;
                this.currentPurchaseValue.purchaseItens.forEach(compraItem => {
                    compraItem.order.orderItens.forEach(cards =>{
                        cards.providedValue = cards.providedValue;
                        cards.referenceValue = cards.referenceValue;
                    })
                })
                this.currentPurchaseValue.purchaseId = this.currentPurchaseValue.purchaseId;
                this.pedidoService.finishPurchase(this.currentUser.token.assignorGuid, this.currentPurchaseValue)
                    .subscribe(
                        response => {

                            if (response.status === ApiError.Sucesso) {

                                this.pedidoService.getPurchaseById(this.currentPurchaseValue.purchaseId,this.currentUser.token.assignorGuid, false).subscribe(
                                    responseInfo => {
                                        if(responseInfo.status === ApiError.Sucesso){
                                            this.pedidoDataService.setCurrentPurchaseInfoValue(responseInfo.result);
                                            this.nextPageAuth = true;
                                            this.router.navigate(['pagamento'], { relativeTo: this.route.parent });
                                        }
                                        else {
                                            this.alertService.error(responseInfo.message);
                                        }
                                    }
                                )
                                //this.purchaseInfo(this.currentPurchaseValue.purchaseId)

                            } else {
                                this.alertService.error(response.message);
                            }
                        }
                    );
                }
            this.updateProgressoTutorial();

        } else {
            this.findInvalidControls()
            if (this.confirmarPedidoFormGroup.controls.dadoBancarioGuid) {
                this.confirmarPedidoFormGroup.controls.dadoBancarioGuid.markAllAsTouched();
            }
        }
        this.saldoCedenteService.updateBalance(this.currentUser.token.assignorGuid);
        this.saldoCedenteService.updateCurrentAccountBalance(this.currentUser.token.assignorGuid);
    }

    public findInvalidControls() {
        const invalid = [];
        const controls = this.confirmarPedidoFormGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                this.confirmarPedidoFormGroup.controls[name].markAllAsTouched();
                this.confirmarPedidoFormGroup.controls[name].markAllAsTouched();
                this.confirmarPedidoFormGroup.controls[name].markAllAsTouched();
                this.confirmarPedidoFormGroup.controls[name].markAllAsTouched();
                //invalid.push(name);
            }
        }
        //return invalid;
    }

    public purchaseInfo(purchaseId: number){

    }

    showModalPin(content){
        this.modalService.open(content, { centered: true});
    }

    solicitarPin(){
        if(!this.isResposavel && this.validarPin){
            this.gestorService.solicitarPin(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId).subscribe(
                res => {
                    if (res.status === ApiError.Sucesso) {
                    } else {
                        this.alertService.error(res.message);
                    }
                }
            );
        }
    }

    verificarPin(pin){
        this.pinMensagemErro = null;
        pin = +pin
        this.gestorService.confirmarPin(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId,pin).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    this.pinValido = true;
                    this.modalService.dismissAll();
                } else {
                    this.pinValido = false;
                    this.pinMensagemErro = res.message;
                }
            }
        );
    }
}

